export default __webpack_public_path__ + "static/media/earthling_9.70a2185a.png";